import { isIOS, isMacOs } from "react-device-detect"

const OsSpecificImage = ({
  appleImage,
  androidImage,
}: {
  appleImage: string
  androidImage: string
}) => {
  if (isIOS || isMacOs) {
    return (
      <img
        alt="Suraasa app preview on iOS"
        className="mx-auto"
        src={appleImage}
      />
    )
  }
  return (
    <img
      alt="Suraasa app preview on android"
      className="mx-auto"
      src={androidImage}
    />
  )
}

export default OsSpecificImage
